import { gql } from '@apollo/client';
import getUserNames from '../../user/getUserNames';
import USER_AVATAR_FRAGMENT from './UserAvatar';

export default gql`
  fragment ReactionFields on Reaction {
    id
    emoji
    author {
      id
      name
      ...UserAvatar
      ...getUserNames_user
    }
    insertedAt
  }
  ${USER_AVATAR_FRAGMENT}
  ${
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line slab-graphql/no-unused-colocated-fragments
    getUserNames.fragments.user
  }
`;
